module.exports = __webpack_public_path__ + "static/media/sonicmania.a57b659c.png";